import axios from "axios";

class IRestClient  {
    static GetRequest = (getUrl) => {
        return axios.get(getUrl).then(response =>{
            return response.data;
        }).catch(error =>{
            return null;
        })
    }

//     static PostRequest = (postUrl,postJson)=>{
//         let config={
//              headers: {
//                   'Content-Type': 'application/x-www-form-urlencoded',
//               }
//         }

//         return axios.post(postUrl,postJson,config).then(response=>{
//              return response.data;
//         }).catch(error=>{
//              return "de";
//         });
//    }

static PostRequest = (postUrl, postJson) => {
    // Set up the configuration with the proper headers for JSON
    const config = {
      headers: {
        'Content-Type': 'application/json',  // Use 'application/json' instead of 'application/x-www-form-urlencoded'
      }
    };
  
    // Perform the POST request using axios, send the postJson as the body in JSON format
    return axios
      .post(postUrl, JSON.stringify(postJson), config)  // Send the data as a stringified JSON
      .then((response) => {
        return response.data;  // Return the response data if successful
      })
      .catch((error) => {
        console.error('Error posting data:', error);  // Log any errors that occur
        return "Error occurred";  // Return a fallback message
      });
  };
  
}

export default IRestClient;